export default __webpack_public_path__ + "static/shean@2x-900766cb78b9560bf4ad23b44a0bb7f4.jpg";